import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import ProgressBar from "../ProgressBar";
import NextBackButton from "../NextBackButton";

export const PropertyUse = ({ formData, setForm, navigation, step }) => {
  const [error, setError] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  const uses = [
    { id: "primaryResidence", title: "Primary Residence" },
    { id: "secondHome", title: "Second Home" },
    { id: "investmentProperty", title: "Investment Property" },
    { id: "fixAndFlip", title: "Fix & Flip" },
  ];

  const checkForNextStep = () => {
    if (formData.propertyUse === "") {
      setError(true);
      console.log("error");
    }
    if (formData.propertyUse !== "") {
      navigation.next();
      console.log("next");
    }
  };

  return (
    <div className="flex flex-col h-screen w-full">
      <ProgressBar width={"68%"} />
      <div className="flex-grow max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center">
              <h1 className="pb-10 text-4xl text-blue-primary font-semibold text-center w-full">
                What is the planned occupancy type?
              </h1>
              <div>
                <label className="text-base font-medium text-gray-900"></label>
                <fieldset className="">
                  <legend className="sr-only">What is the planned occupancy type?</legend>
                  <div className="space-y-3">
                    {uses.map((usesDescription) => (
                      <div key={usesDescription.id} className="flex items-center">
                        <input
                          checked={formData.propertyUse === usesDescription.id}
                          onChange={setForm}
                          value={usesDescription.id}
                          id={usesDescription.id}
                          name="propertyUse"
                          type="radio"
                          className="h-4 w-4 text-white border-gray-satan"
                        />
                        <label htmlFor={usesDescription.id} className="ml-3 block text-xl font-medium text-gray-satan">
                          {usesDescription.title}
                        </label>
                      </div>
                    ))}
                    {error ? <p className="text-red-error text-center">Please fill out an answer</p> : null}
                  </div>
                </fieldset>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
      <NextBackButton goBack={() => navigation.previous()} callBack={checkForNextStep} />
    </div>
  );
};
